// extracted by mini-css-extract-plugin
module.exports = {"header":"ProductPage_header_1Z-UE"};